import React from "react";
import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/mainPage";
import App from "../App";
import ProductCenter from "../pages/productCenter";
import SecondProduct from "../pages/productCenter/secondProduct";
import Solution from "../pages/solution";
import Support from "../pages/support";
import Ours from "../pages/ours";
import DownLoad from "../pages/download";
import DownLoadForm from "../pages/download/downLoadForm";
import SubSolution from "../pages/solution/SubSolution";
import SolutionContent from "../pages/solution/SolutionContent";
import NotFound from "../pages/NotFound/NotFound";
import Tech from "../pages/customer";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: "mainPage",
        element: <MainPage />,
      },
      {
        path: "product",
        element: <ProductCenter />,
      },
      {
        path: "product/detail/:itemId",
        element: <SecondProduct />,
      },
      {
        path: "download",
        element: <DownLoad />,
      },
      {
        path: "solution",
        element: <Solution />,
      },
      {
        path: "solution/:solutionId",
        element: <SubSolution />,
      },
      {
        path: "solution/:solutionId/:solutionContentId",
        element: <SolutionContent />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "tech",
        element: <Tech />,
      },
      {
        path: "ours",
        element: <Ours />,
      },
    ],
  },
  {
    path: "/download/tryBussines",
    element: <DownLoadForm />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
